import { getInboxCounters } from 'ha/modules/InboxCounter/actions';
import { markAsReadAction as talkMarkAsRead } from './actions';

export default (userId, conversationId) => (dispatch, _, { apiV2 }) =>
  apiV2
    .markConversationAsRead(conversationId)
    .then(() => {
      dispatch(talkMarkAsRead.done(conversationId));
      dispatch(getInboxCounters(userId));
    })
    .catch(error => {
      dispatch(talkMarkAsRead.error(error));
    });
